export const appprox = 0.01;
export const TVA = [0, 2.1, 5.5, 10, 20];
export const URLGED = "https://gedfi.inserm.fr";
